import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { EVENT_QUERY_KEYS } from '../../../constants/queryKeys';
import EventApi2 from '../../../lib/api/event/EventApiV2';
import { QueryOptions } from '../../../types/query/useQuery';
import { EventsFindOneResponseBodyDto } from '../../../types/api/events';

type UseEventDetailQueryArgsType<SelectResultType> = {
  payload: number;
  options?: QueryOptions<EventsFindOneResponseBodyDto, unknown, SelectResultType>;
};
const useEventDetail = <SelectResultType>({
  payload,
  options,
}: UseEventDetailQueryArgsType<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<EventsFindOneResponseBodyDto, unknown, SelectResultType>(
    [...EVENT_QUERY_KEYS.DETAIL, payload],
    (): Promise<EventsFindOneResponseBodyDto> => EventApi2.getEventDetail(payload),
    { ...options },
  );
};

export default useEventDetail;
